import { Component, OnInit } from '@angular/core';
import { ManageUserService } from '../manage-user.service';
import { User } from '../../../core/user';

@Component({
  selector: 'app-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.css']
})
export class ManageUserComponent implements OnInit {
  userList: User[];
  filter = {
    radio: '',
    email: ''
  };
  constructor(private manageUserService: ManageUserService) {}

  ngOnInit() {
    console.log('in manageuser compenent');
    const x = this.manageUserService.getData();
    /**
     * convert firelist into user array
     * that's why snapshotchanges used
     *
     * subscribe executed whenever there is chnage in datacollection
     *
     * item contain collection on employee
     * so convet into array we have to iterate
     *
     * payload.jSON() return json object of data
     *
     * for key  we need
     */
    x.valueChanges().subscribe(item => {
      this.userList = item;
      this.userList.sort((a: User, b: User) => {
        const aWeight = a.roles.superAdmin
          ? 7
          : a.roles.admin
            ? 3
            : a.roles.editor
              ? 2
              : 1;
        const bWeight = b.roles.superAdmin
          ? 7
          : b.roles.admin
            ? 3
            : b.roles.editor
              ? 2
              : 1;
        if (bWeight - aWeight === 0) {
          return a.displayName.localeCompare(b.displayName);
        }
        return bWeight - aWeight;
      });
    });
  } // onInt

  Edit(uid: string) {
    console.log(uid);
  }
  filterData() {
    const x = this.manageUserService.filterData(this.filter);
    /**
     * convert firelist into user array
     * that's why snapshotchanges used
     *
     * subscribe executed whenever there is chnage in datacollection
     *
     * item contain collection on employee
     * so convet into array we have to iterate
     *
     * payload.jSON() return json object of data
     *
     * for key  we need
     */
    x.valueChanges().subscribe(item => {
      this.userList = item;
      this.userList.sort((a: User, b: User) => {
        const aWeight = a.roles.superAdmin
          ? 7
          : a.roles.admin
            ? 3
            : a.roles.editor
              ? 2
              : 1;
        const bWeight = b.roles.superAdmin
          ? 7
          : b.roles.admin
            ? 3
            : b.roles.editor
              ? 2
              : 1;
        if (bWeight - aWeight === 0) {
          return a.displayName.localeCompare(b.displayName);
        }
        return bWeight - aWeight;
      });
    });
  }
  reset() {
    this.filter = {
      radio: '',
      email: ''
    };
    this.ngOnInit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/manage-user/manage-user/manage-user.component.ts